import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { ErrorReportingService } from '../services/error-reporting/error-reporting.service';
import { UpdateNotifierService } from '../services/update/update-notifier.service';
import { GlobalErrorHandler } from './global-error.handler';

@Injectable()
export class DeferredErrorHandler implements ErrorHandler {
  private realErrorHandler: GlobalErrorHandler | null = null;
  private pendingErrors: any[] = [];
  private initialised = false;

  constructor(
    private injector: Injector,
    private ngZone: NgZone
  ) {
    // We'll initialise the real handler after APP_INITIALIZER completes and the auth0 service has had it its config loaded
    // This allows us to do API calls as the API service in ErrorReportingService depends on the auth0 service
  }

  initialiseRealHandler() {
    this.ngZone.run(() => {
      const errorReportingService = this.injector.get(ErrorReportingService);
      const updateNotifierService = this.injector.get(UpdateNotifierService);

      this.realErrorHandler = new GlobalErrorHandler(
        errorReportingService,
        this.ngZone,
        updateNotifierService
      );

      this.initialised = true;

      if (this.pendingErrors.length > 0) {
        const errors = [...this.pendingErrors];
        this.pendingErrors = [];
        errors.forEach(error => this.handleError(error));
      }
    });
  }

  handleError(error: any) {
    if (this.initialised && this.realErrorHandler) {
      this.realErrorHandler.handleError(error);
    } else {
      console.error('Application initialising, error queued:', error);
      this.pendingErrors.push(error);
    }
  }
}
